import { memo } from 'react';
import { Text } from '@doda/io-react/common';
import { useAppSelector } from 'redux/hooks';
import { jobContentLinkSelector } from '@doda/common/src/redux/features/JobContent/jobContentLink';
import { OtherPageLinkItem } from '@doda/pc/src/components/JobContent/OtherPageLinkItem';
import {
  OTHER_PAGE_LINK_TITLE,
  JOB_TREND_LINK_TEXT,
  JOB_RANKING_LINK_TEXT,
  OCCUPATION_LINK_TEXT,
} from '@doda/common/src/constants/seo/jobContentCommonConstants';
import styles from './index.module.scss';

export const JobContentLink = memo(() => {
  const jobContents = useAppSelector(jobContentLinkSelector);

  return (
    <>
      {jobContents.jobContentLink.map((jobContent, i) => (
        <div key={i} className={styles.jobContentLink}>
          <Text
            as="h2"
            size="20"
            color="black_pc"
            weight="bold"
            className={styles.jobContentLink__title}
          >
            {jobContent.targetName}
            {OTHER_PAGE_LINK_TITLE}
          </Text>
          {jobContent.linkList.map(
            (linkItem) =>
              linkItem && (
                <>
                  <div className={styles.jobContentLink__list}>
                    <OtherPageLinkItem
                      title={JOB_TREND_LINK_TEXT.TITLE}
                      description={JOB_TREND_LINK_TEXT.DESCRIPTION}
                      linkUrl={linkItem.jobTrendUrl}
                      imagePath={JOB_TREND_LINK_TEXT.IMAGE_PATH}
                    />
                    <OtherPageLinkItem
                      title={JOB_RANKING_LINK_TEXT.TITLE}
                      description={JOB_RANKING_LINK_TEXT.DESCRIPTION}
                      linkUrl={linkItem.jobRankingUrl}
                      imagePath={JOB_RANKING_LINK_TEXT.IMAGE_PATH}
                    />
                    {linkItem.occupationUrl && (
                      <OtherPageLinkItem
                        title={OCCUPATION_LINK_TEXT.TITLE}
                        description={OCCUPATION_LINK_TEXT.DESCRIPTION}
                        linkUrl={linkItem.occupationUrl}
                        imagePath={OCCUPATION_LINK_TEXT.IMAGE_PATH}
                      />
                    )}
                  </div>
                </>
              )
          )}
        </div>
      ))}
    </>
  );
});

JobContentLink.displayName = 'JobContentLink';
